module.exports = __webpack_public_path__ + "static/media/cerchio.c638814d.svg";